/**
 * The tab strip shown while a process is open. Labels double as values so the
 * segmented control can take them straight — the same shape KuikaTabs expects.
 */
export const PROCESS_TAB_DIAGRAM = "Diagram";
export const PROCESS_TAB_PARAMETERS = "Parameters";
export const PROCESS_TAB_FORMS = "Forms";
export const PROCESS_TAB_VERSION_HISTORY = "Version History";

// NOTE: the former "Happy Path" tab was retired — phases are managed entirely on the diagram as
// native bpmn:Group columns (see moddle/happyPathPhaseInterceptor.tsx).
export const PROCESS_EDITOR_TABS: string[] = [
  PROCESS_TAB_DIAGRAM,
  PROCESS_TAB_PARAMETERS,
  PROCESS_TAB_FORMS,
  PROCESS_TAB_VERSION_HISTORY
];

/**
 * The Diagram tab keeps the BPMN modeler mounted underneath every other tab, so the
 * bpmn-js instance is never torn down and re-imported on a tab switch. Everything
 * else renders as an overlay above it.
 */
export const isDiagramTab = (tab: string): boolean => tab === PROCESS_TAB_DIAGRAM;

/**
 * Test-id for one tab of the strip, e.g. "Version History" -> `processEditorTab-version-history`.
 *
 * The strip IS the process editor's navigation since KOA-15840 folded the editor header into the
 * shell sub-bar, and it is the only route to Parameters / Forms / Version History now that the
 * workflow left-menu buttons are gone. rc-segmented paints a radio input over each option, so the
 * suite clicks the owning `<label>` (BasePage.selectSegmentedOptionByTestId) — it still needs a
 * per-option hook to find that label by. `toLowerCase` is locale-independent in JS, so the id is
 * stable under a Turkish locale.
 */
export const processEditorTabTestId = (tab: string): string =>
  `processEditorTab-${tab.toLowerCase().replace(/\s+/g, "-")}`;
